/*
 * @Author: changcheng 364000100@#qq.com
 * @Date: 2025-07-07 15:35:12
 * @LastEditors: changcheng 364000100@#qq.com
 * @LastEditTime: 2025-07-10 15:58:07
 * @FilePath: /mvw_project/project_login_frontend/src/page/component/signup/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useState, useEffect, useRef } from "react";
import { Form, Input, Button, Select, message } from "antd";
import { encode } from "js-base64";
import "./index.scss";

// 移动端组件动态导入
let MobileForm: any;
let MobileInput: any;
let MobileButton: any;
let MobileSelector: any;
let MobilePicker: any;
let MobileSearchBar: any;
let MobileToast: any;

// 检测是否为移动端
const isMobile = () => {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) || window.innerWidth <= 768
  );
};

/**报名组件
 * 参数
 * onSubmit 报名提交回调
 */
// 机构接口数据类型
interface Institute {
  instituteId: string;
  instituteName: string;
}

interface ApiResponse {
  code: number;
  data: Institute[];
  msg: string;
}

// 报名接口数据类型
interface EnrollRequest {
  projectId: number;
  cellPhone: string;
  name: string;
  instituteId: string;
}

interface EnrollResponse {
  code: number;
  data?: any;
  msg: string;
}

function Signup(props: any) {
  const { onSubmit } = props;
  const [form] = Form.useForm();
  const [organizationList, setOrganizationList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [mobileComponentsLoaded, setMobileComponentsLoaded] = useState(false);
  const [currentIsMobile, setCurrentIsMobile] = useState(false);

  // 移动端专用状态
  const [selectedOrganization, setSelectedOrganization] = useState("");
  const [selectedOrganizationName, setSelectedOrganizationName] = useState("");

  const [filteredOrganizations, setFilteredOrganizations] = useState([]);
  const [showMobilePicker, setShowMobilePicker] = useState(false);
  const [tempSelectedOrganization, setTempSelectedOrganization] = useState("");
  let searchText = "";
  // 搜索输入框ref
  const searchInputRef = useRef(null);

  // 搜索机构
  const handleSearch = () => {
    if (!searchText.trim()) {
      setFilteredOrganizations(organizationList);
    } else {
      const filtered = organizationList.filter((org: any) =>
        org.label.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredOrganizations(filtered);
    }
  };

  // 从URL获取projectId（支持普通URL和Hash路由）
  const getProjectIdFromUrl = (): number => {
    let projectId: string | null = null;

    // 先尝试从普通URL参数获取
    const urlParams = new URLSearchParams(window.location.search);
    projectId = urlParams.get("projectId");

    // 如果普通URL没有，尝试从hash中获取
    if (!projectId && window.location.hash) {
      const hashParams = new URLSearchParams(
        window.location.hash.split("?")[1] || ""
      );
      projectId = hashParams.get("projectId");
    }

    const id = projectId ? parseInt(projectId, 10) : 775; // 默认值775
    console.log(
      "当前使用的ProjectID:",
      id,
      projectId ? "(从URL获取)" : "(使用默认值)",
      "URL:",
      window.location.href
    );
    return id;
  };

  // 获取机构列表
  const fetchInstituteList = async () => {
    try {
      setLoading(true);
      const projectId = getProjectIdFromUrl();
      const response = await fetch(
        `/shop/api/${projectId}/activity/institute/list`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result: ApiResponse = await response.json();

      if (result.code === 0 && result.data) {
        // 转换数据格式为Select组件需要的格式
        const options = result.data.map((institute) => ({
          value: institute.instituteId,
          label: institute.instituteName,
        }));
        setOrganizationList(options);
        setFilteredOrganizations(options); // 同时更新过滤列表
        console.log("成功获取机构列表:", options);
      } else {
        message.error(result.msg || "获取机构列表失败");
        console.error("API返回错误:", result);
      }
    } catch (error) {
      console.error("获取机构列表失败:", error);
      message.error("获取机构列表失败，请检查网络连接后重试");
      // 可以添加默认的机构列表作为fallback
      setOrganizationList([
        { value: "default", label: "默认机构（请刷新重试）" },
      ]);
    } finally {
      setLoading(false);
    }
  };

  // 动态加载移动端组件
  const loadMobileComponents = async () => {
    if (isMobile()) {
      try {
        // @ts-ignore - 动态导入antd-mobile组件
        const antdMobile = await import("antd-mobile");
        MobileForm = antdMobile.Form;
        MobileInput = antdMobile.Input;
        MobileButton = antdMobile.Button;
        MobileSelector = antdMobile.Selector;
        MobilePicker = antdMobile.Picker;
        MobileSearchBar = antdMobile.SearchBar;
        MobileToast = antdMobile.Toast;
        setMobileComponentsLoaded(true);
      } catch (error) {
        console.warn("antd-mobile未安装，使用PC端组件");
        setMobileComponentsLoaded(false);
      }
    }
    setCurrentIsMobile(isMobile());
  };

  // 组件挂载时检测设备并获取机构列表
  useEffect(() => {
    loadMobileComponents();
    fetchInstituteList();
  }, []);

  // 重置移动端选择状态
  const resetMobileState = () => {
    setSelectedOrganization("");
    setSelectedOrganizationName("");
    searchText = "";
    setFilteredOrganizations(organizationList);
    setShowMobilePicker(false);
    setTempSelectedOrganization("");
  };

  // 搜索过滤函数
  const filterOption = (
    input: string,
    option?: { label: string; value: string }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  // 自定义移动端机构选择组件
  const MobileOrganizationPicker = () => {
    // 处理选择确认
    const handlePickerConfirm = () => {
      if (tempSelectedOrganization) {
        const selectedItem = organizationList.find(
          (org: any) => org.value === tempSelectedOrganization
        );
        if (selectedItem) {
          setSelectedOrganization(tempSelectedOrganization);
          setSelectedOrganizationName(selectedItem.label);
          form.setFieldsValue({ organization: tempSelectedOrganization });
        }
      }
      setShowMobilePicker(false);
    };

    // 处理列表项选择
    const handleItemSelect = (orgValue: string, orgLabel: string) => {
      setTempSelectedOrganization(orgValue);
    };

    return (
      <>
        {/* 触发器 */}
        <div
          style={{
            padding: "12px",
            border: "1px solid #e1e8ed",
            borderRadius: "8px",
            background: "white",
            minHeight: "44px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            userSelect: "none",
          }}
          onClick={() => {
            if (!loading && organizationList.length > 0) {
              setTempSelectedOrganization(selectedOrganization);
              setShowMobilePicker(true);
              // 立即聚焦到搜索框
              setTimeout(() => {
                if (searchInputRef.current) {
                  searchInputRef.current.focus();
                  console.log("点击触发器后立即聚焦");
                }
              }, 50);
            }
          }}
        >
          <span
            style={{
              color: selectedOrganizationName ? "#2c3e50" : "#a0aec0",
              fontSize: "16px",
            }}
          >
            {loading
              ? "正在加载机构列表..."
              : selectedOrganizationName || "请点击选择机构"}
          </span>
          <span style={{ color: "#999", fontSize: "12px" }}>▼</span>
        </div>

        {/* 搜索和选择弹窗 */}
        {showMobilePicker && (
          <div
            className="mobile-picker-overlay"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0, 0, 0, 0.5)",
              zIndex: 9999,
              display: "flex",
              alignItems: "flex-end",
            }}
          >
            <div
              className="mobile-picker-content"
              style={{
                background: "white",
                width: "100%",
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                maxHeight: "80vh",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* 头部操作栏 */}
              <div
                style={{
                  padding: "16px",
                  borderBottom: "1px solid #f0f0f0",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  background: "#fafafa",
                }}
              >
                <button
                  onClick={() => {
                    setShowMobilePicker(false);
                    searchText = ""; // 重置搜索
                    setFilteredOrganizations(organizationList);
                    setTempSelectedOrganization("");
                  }}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#999",
                    fontSize: "16px",
                    padding: "8px",
                  }}
                >
                  取消
                </button>
                <span
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: "#2c3e50",
                  }}
                >
                  选择机构
                </span>
                <button
                  onClick={handlePickerConfirm}
                  style={{
                    background: "none",
                    border: "none",
                    color: tempSelectedOrganization ? "#667eea" : "#ccc",
                    fontSize: "16px",
                    padding: "8px",
                  }}
                  disabled={!tempSelectedOrganization}
                >
                  确定
                </button>
              </div>
              <div
                style={{
                  padding: "16px",
                  borderBottom: "1px solid #f0f0f0",
                  background: "#fafafa",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <Input
                    onChange={(e: any) => {
                      searchText = e.target.value;
                    }}
                    style={{
                      flex: 1,
                      padding: "12px 16px",
                      border: "1px solid #e1e8ed",
                      borderRadius: "25px",
                      fontSize: "16px",
                      outline: "none",
                      background: "white",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    }}
                  />
                  <button
                    onClick={handleSearch}
                    style={{
                      padding: "12px 24px",
                      background: "#667eea",
                      color: "white",
                      border: "none",
                      borderRadius: "25px",
                      fontSize: "16px",
                      cursor: "pointer",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      transition: "all 0.2s ease",
                      WebkitTapHighlightColor: "transparent",
                    }}
                    onTouchStart={(e) => {
                      e.currentTarget.style.transform = "scale(0.98)";
                      e.currentTarget.style.opacity = "0.9";
                    }}
                    onTouchEnd={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.opacity = "1";
                    }}
                  >
                    搜索
                  </button>
                </div>
              </div>

              {/* 机构列表 */}
              <div
                style={{
                  flex: 1,
                  overflow: "auto",
                  minHeight: "300px",
                }}
              >
                {loading ? (
                  <div
                    style={{
                      padding: "40px",
                      textAlign: "center",
                      color: "#999",
                      fontSize: "16px",
                    }}
                  >
                    <div>正在加载机构列表...</div>
                  </div>
                ) : filteredOrganizations.length === 0 ? (
                  <div
                    style={{
                      padding: "40px",
                      textAlign: "center",
                      color: "#999",
                      fontSize: "16px",
                    }}
                  >
                    <div style={{ marginBottom: "8px" }}>
                      暂无匹配的机构数据
                    </div>
                  </div>
                ) : (
                  <div style={{ padding: "0" }}>
                    {filteredOrganizations.map((org: any) => (
                      <div
                        key={org.value}
                        style={{
                          padding: "16px 20px",
                          borderBottom: "1px solid #f0f0f0",
                          background:
                            tempSelectedOrganization === org.value
                              ? "#f0f8ff"
                              : "white",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          position: "relative",
                        }}
                        onClick={() => handleItemSelect(org.value, org.label)}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              color:
                                tempSelectedOrganization === org.value
                                  ? "#667eea"
                                  : "#2c3e50",
                              fontSize: "16px",
                              fontWeight:
                                tempSelectedOrganization === org.value
                                  ? "600"
                                  : "normal",
                            }}
                          >
                            {org.label}
                          </span>
                          {tempSelectedOrganization === org.value && (
                            <span
                              style={{
                                color: "#667eea",
                                fontSize: "18px",
                                fontWeight: "bold",
                              }}
                            >
                              ✓
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  // 提交报名数据
  const submitEnrollment = async (enrollData: EnrollRequest) => {
    try {
      setSubmitting(true);
      console.log("发送报名请求:", enrollData);

      const response = await fetch("/shop/api/activity/enroll", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(enrollData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result: EnrollResponse = await response.json();
      console.log("报名接口返回:", result);

      if (result.code === 0) {
        if (currentIsMobile && MobileToast) {
          MobileToast.show({
            content: "🎉 报名成功！我们会尽快与您联系。",
            position: "center",
          });
        } else {
          message.success("🎉 报名成功！我们会尽快与您联系。");
        }
        form.resetFields(); // 清空表单
        // 如果是移动端，也重置移动端专用状态
        if (currentIsMobile) {
          resetMobileState();
        }
        onSubmit && onSubmit(result); // 调用父组件回调
      } else {
        if (currentIsMobile && MobileToast) {
          MobileToast.show({
            content: result.msg || "报名失败，请重试",
            position: "center",
          });
        } else {
          message.error(result.msg || "报名失败，请重试");
        }
      }
    } catch (error) {
      console.error("报名提交失败:", error);
      // 根据错误类型给出不同提示
      const errorMessage = (error as Error).message || "";
      let errorText = "报名提交失败，请稍后重试";
      if (errorMessage.includes("Failed to fetch")) {
        errorText = "网络连接失败，请检查网络后重试";
      } else if (errorMessage.includes("HTTP error")) {
        errorText = "服务器响应异常，请稍后重试";
      }

      if (currentIsMobile && MobileToast) {
        MobileToast.show({ content: errorText, position: "center" });
      } else {
        message.error(errorText);
      }
    } finally {
      setSubmitting(false);
    }
  };

  /**表单提交事件 */
  const onFinish = async (values: any) => {
    // 移动端需要特殊处理机构选择
    const organizationValue = currentIsMobile
      ? selectedOrganization
      : values.organization;

    // 验证必填字段
    if (!values.mobile || !values.name || !organizationValue) {
      const errorMsg = "请填写完整的报名信息";
      if (currentIsMobile && MobileToast) {
        MobileToast.show({ content: errorMsg, position: "center" });
      } else {
        message.error(errorMsg);
      }
      return;
    }

    // 构造报名数据
    const projectId = getProjectIdFromUrl();
    const enrollData: EnrollRequest = {
      projectId: projectId, // 从URL获取项目ID
      cellPhone: values.mobile.trim(), // 去除首尾空格
      name: values.name.trim(), // 去除首尾空格
      instituteId: organizationValue, // 机构ID
    };

    console.log("提交的报名数据:", enrollData);
    await submitEnrollment(enrollData);
  };

  // 渲染移动端表单
  const renderMobileForm = () => {
    if (!mobileComponentsLoaded || !MobileForm) {
      return renderPCForm(); // 如果移动端组件未加载，回退到PC端
    }

    return (
      <div className="signupForm mobile-form">
        <MobileForm
          onFinish={onFinish}
          footer={
            <MobileButton
              block
              type="submit"
              color="primary"
              size="large"
              loading={submitting}
              disabled={submitting}
            >
              {submitting ? "提交中..." : "提交"}
            </MobileButton>
          }
        >
          <MobileForm.Item
            name="mobile"
            rules={[
              { required: true, message: "请输入您的手机号码" },
              { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码" },
            ]}
          >
            <MobileInput placeholder="请输入手机号" />
          </MobileForm.Item>
          <MobileForm.Item
            name="name"
            rules={[{ required: true, message: "请输入您的姓名" }]}
          >
            <MobileInput placeholder="请输入姓名" />
          </MobileForm.Item>

          <MobileForm.Item name="organization">
            <MobileOrganizationPicker />
          </MobileForm.Item>
        </MobileForm>
      </div>
    );
  };

  // 渲染PC端表单
  const renderPCForm = () => {
    return (
      <Form className="signupForm" form={form} onFinish={onFinish}>
        <Form.Item
          name="mobile"
          rules={[
            { required: true, message: "请输入您的手机号码" },
            { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码" },
          ]}
        >
          <Input placeholder="请输入手机号" style={{ width: "300px" }} />
        </Form.Item>

        <Form.Item
          name="name"
          rules={[{ required: true, message: "请输入您的姓名" }]}
        >
          <Input placeholder="请输入姓名" style={{ width: "300px" }} />
        </Form.Item>

        <Form.Item
          name="organization"
          rules={[{ required: true, message: "请选择机构" }]}
        >
          <Select
            placeholder={
              loading ? "正在加载机构列表..." : "请输入关键词搜索机构"
            }
            options={organizationList}
            showSearch
            filterOption={filterOption}
            allowClear
            loading={loading}
            style={{ width: "300px" }}
            notFoundContent={loading ? "加载中..." : "未找到匹配的机构"}
            dropdownRender={(menu) => (
              <div>
                {menu}
                <div
                  style={{
                    padding: "8px",
                    borderTop: "1px solid #f0f0f0",
                    textAlign: "center",
                  }}
                >
                  <Button
                    type="link"
                    size="small"
                    onClick={fetchInstituteList}
                    disabled={loading}
                  >
                    {loading ? "加载中..." : "刷新列表"}
                  </Button>
                </div>
              </div>
            )}
          />
        </Form.Item>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            htmlType="submit"
            block
            loading={submitting}
            disabled={submitting}
          >
            {submitting ? "提交中..." : "提交"}
          </Button>
        </Form.Item>
      </Form>
    );
  };

  return (
    <div>
      {/* 根据设备类型渲染不同的表单 */}
      {currentIsMobile && mobileComponentsLoaded
        ? renderMobileForm()
        : renderPCForm()}
    </div>
  );
}

export default Signup;
